import { sanitize } from "isomorphic-dompurify";

export function sanitizeInputText(text: string) {
  const sanitizedValue = sanitize(text);
  return sanitizedValue.replace(/&lt;/g, "<").replace(/&gt;/g, ">");
}
